module.exports = __webpack_public_path__ + "static/media/SWSCRC6-7.e02a35aa.mp3";